export let life = {
  mounted () {
    this.methods('setPropToLabelObj')
    this.methods('getPropToLabel')
    this.$nextTick(() => {
      // 判断是否要显示扩展
      this.methods('autoExpand')
    })
    $(window).on('resize', () => {
      this.methods('autoExpand')
    })
    $(this.$refs.table.$el).on('mousedown', e => {
      if (e.ctrlKey && e.buttons === 1) {
      }
    })
    // this.tableAutoHeight = $(this.$refs.TTable).height()
    this.methods('autoHeightCompute');
    // 监听窗口大小变化
    this.onResize = () => {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = undefined;
        this.debounceTimer = setTimeout(() => {
          this.methods('autoHeightCompute');
        }, 100);
      } else {
        this.debounceTimer = setTimeout(() => {
          this.methods('autoHeightCompute');
        }, 100);
      }
    }
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy(){
    clearTimeout(this.debounceTimer);
    window.removeEventListener('resize', this.onResize)
  }
}
export let event = {
  /**
   * 点击某一行，转发element-ui的接口给父组件用
   * @param row 行数据
   * @param event 点击事件对象
   * @param column 列数据
   */
  clickTr (row, event, column) {
    this.methods('clickTr', ...arguments)
  },
  clickTd () {
    this.methods('clickTd', ...arguments)
  },
  handleSelectionChange () {
    this.methods('handleSelectionChange', ...arguments)
  },
  select () {
    this.methods('select', ...arguments)
  },
  selectAll () {
    this.methods('selectAll', ...arguments)
  },
  sortChange () {
    this.methods('sortChange', ...arguments)
  },
  tableRowClassName({row, rowIndex}) {
    if (row.currentColor) {
      return 'current-row-color'
    }
    return ''
  },
  formatEmpty (value) {
    return this.methods('formatEmpty', value)
  }
}
export let watch = {
  // 当不可折叠的时候，将那些折叠产生的tr去掉
  currentExpand () {
    if (!this.currentExpand) {
      $(this.$refs.TTable).find('.el-table__expanded-cell').parent().remove()
    }
  },
  // hideLevel发生改变时
  hideLevel () {
    if (this.hideLevel.length > 0) {
      this.currentExpand = true
    } else {
      this.currentExpand = false
    }
  },
  // 当数据改变，需要重新计算最小宽度
  tableData () {
    // if (_.isEmpty(this.tableData))return 管它有没有数据，都要计算
    this.methods('setPropToLabelObj')
    this.$nextTick(() => {
      // 判断是否要显示扩展
      this.methods('autoExpand')
      // 点击第一列
      this.$nextTick(() => {
        $(this.$refs.table.$el).find('tbody tr:eq(0)').trigger('click')
      })
    })
  }
}
